import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import packageJson from '../../package.json';

const GameRun = () => {
  // Derive app name from hostname: strip www. and TLD → e.g. "bajilive - APP"
  const hostname = window.location.hostname
    .replace(/^www\./, '')
    .replace(/\.(com|live|net|world|bet|buzz|win|pro|top|site|xyz)$/i, '');
  const appName = hostname ? `${hostname} - APP` : packageJson.name;
  const version = packageJson.version;
  const location = useLocation();
  const navigate = useNavigate();
  const { iframeUrl, fromParams, apiMode } = location.state || {};
  const username = localStorage.getItem('username');

  const [loading, setLoading] = useState(true);
  const [exitMessage, setExitMessage] = useState(null);

  const handleClose = async () => {
    if (apiMode === 'transfer') {
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/9wkt/exit`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });
        if (res.ok) {
          const data = await res.json();
          setExitMessage(`Balance Returned: ${data.returned ?? data.balance ?? ''}`);
          setTimeout(() => {
            if (fromParams) {
              const { type, system, title } = fromParams;
              navigate(`/casino?type=${encodeURIComponent(type)}&system=${encodeURIComponent(system)}&title=${encodeURIComponent(title)}`);
            } else {
              navigate(-1);
            }
          }, 1500);
          return;
        }
      } catch (e) {
        // fall through to default nav
      }
    }
    if (fromParams) {
      const { type, system, title } = fromParams;
      navigate(`/casino?type=${encodeURIComponent(type)}&system=${encodeURIComponent(system)}&title=${encodeURIComponent(title)}`);
    } else {
      // Go back to wherever the game was launched from
      navigate(-1);
    }
  };

  return (
    <div className="cdk-overlay-container">
      {exitMessage && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 999999999, background: 'rgba(0,0,0,0.6)',
        }}>
          <div style={{
            background: '#1a1a2e', color: '#e8ce78', padding: '24px 36px',
            borderRadius: '12px', fontSize: '18px', fontWeight: 'bold',
            textAlign: 'center', boxShadow: '0 4px 24px rgba(0,0,0,0.5)',
          }}>
            {exitMessage}
          </div>
        </div>
      )}
      <div
        className="cdk-global-overlay-wrapper"
        dir="ltr"
        style={{
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column"
        }}
      >

        {/* Header */}
        <div
          style={{
            position: "sticky",
            top: 0,
            width: "100%",
            background: "#0f0f0f",
            zIndex: 9999,
            padding: "2px 15px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid rgba(255,255,255,0.1)"
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ color: "#00d4c3", fontWeight: "600", fontSize: "14px" }}>
              {appName}
              <span style={{ color: "#576775", marginLeft: 5 }}>
                - v.{version}
              </span>
            </span>
            <span style={{ color: "#ffffff", fontSize: "14px", fontWeight: "700" }}>
              {username}
            </span>
          </div>

          <div
            onClick={handleClose}
            style={{
              fontSize: "22px",
              color: "#ffffff",
              cursor: "pointer",
              fontWeight: "bold"
            }}
          >
            <img
              width={20}
              alt="close"
              src="https://img.b112j.com/bj/h5/assets/v3/images/icon-set/utility-type/icon-close.svg?v=1770792598866"
            />
          </div>
        </div>

        {/* Iframe Section */}
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "100%",
            background: "#000"
          }}
        >
          {/* 🔥 Loader */}
          {loading && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",
                background: "#6f7b84",
                paddingBottom: "150px",
                zIndex: 999
              }}
            >
              <div className="dot-loaderss">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          )}


          <iframe
            name="myiFrame"
            width="100%"
            height="100%"
            allowFullScreen
            style={{
              border: "none",
              display: "block"
            }}
            scrolling="yes"
            src={iframeUrl}
            title="Game"
            onLoad={() => setLoading(false)}
          />
        </div>
      </div>
    </div>
  );
};

export default GameRun;
